import { defaultLocale, type Locale } from "../../i18n/translations";
import { translate, type TranslationParams } from "../../i18n/translate";

let currentLocale: Locale = defaultLocale;

export const setUiLocale = (locale: Locale) => {
  currentLocale = locale;
};

export const getUiLocale = () => currentLocale;

export const tRuntime = (key: string, fallback: string, params?: TranslationParams) =>
  translate(currentLocale, key, fallback, params);
